import React from 'react';
import { InputGroup } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'moment/locale/sv';
import "react-day-picker/lib/style.css";
import _ from 'underscore';
import './style.scss';

class DayPickerInputWithAddon extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let { label, width, addonText, placeholder, format, value, onChange, className, disabled = false } = this.props

        return (
            <div>
                <DayPickerInput
                    label={label}
                    small
                    className={className || 'form-control'}
                    placeholder={placeholder}
                    disabled={disabled}
                    format={format || "YYYY-MM-DD"}
                    width={width}
                    value={value}
                    onDayChange={onChange}
                    component={DayPickerAddon} 
                />
            </div>
           )
    }
}

class DayPickerAddon extends React.Component {
    constructor(props) {
        super(props);
        this.focus = this.focus.bind(this);
    }

    focus() {
        this.inputRef.focus();
    }

    render() {
        const { label, width, placeholder, disabled, small, className } = this.props;
        const rest = _.pick(this.props, ['onBlur', 'onChange', 'onFocus', 'onKeyUp', 'value']);

        // Jag la till en optional width parameter som skickas fr�n DayPickerInputWithAddon -
        // exempelvis fr�n components/Admin/GlobalSettings/BannerSettings.
        // 300px ligger kvar som default-v�rde eftersom det fortfarande kan vara andra st�llen 
        // i portalen som anv�nder denna h�rdkodade width p� sina DayPickerInputWithAddon.

        return (
            <InputGroup className={small ? 'input-group-sm' : ''}>
                <InputGroup.Addon>{label}</InputGroup.Addon>
                <input disabled={disabled} readOnly className={className} type="text" style={{ width: width || '300px', backgroundColor: 'white' }} placeholder={placeholder} {...rest} ref={(input) => { this.inputRef = input }} />
            </InputGroup>
        )
    }
}

export default DayPickerInputWithAddon;